import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ConfirmationModal from '../../component/modal/ConfirmationModal';
import {
	delete_credit_note,
	generatePurchaseCreditNotePdf,
	getCreditNoteDetails,
} from '../../services/credit_note';
import Button from '../../component/ui/Button';
import { numberToWords } from '../../utils/helper';
import { toast } from 'react-toastify';
import { getDate } from '../../utils/dateUtils';
import ProductDetailsDrawer from '../components/ProductDetailsDrawer';
import PaymentMadeDetailTable from '../paymentMade/components/PaymentMadeDetailTable';
import PageLoader from '../../component/PageLoader';
import ApplyInvoice from '../components/applyInvoice';
import BillDetailDrawer from '../components/billDetailDrawer';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../utils/controller';

const CreditNoteDetails = () => {
	const suburl = localStorage.getItem('suburl');
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const params = useParams();
	const navigate = useNavigate();
	const { id } = params;
	const [isPBDrawerOpen, setIsPBDrawerOpen] = useState(false);
	const [pbId, setPbId] = useState('');
	const [creditNoteDetails, setCreditNoteDetails] = useState(null);
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [isApplyInvoice, setIsApplyInvoice] = useState(false);
	const [productDetails, setProductDetails] = useState(null);
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);
	const [loader, setLoader] = useState(false);
	const printPdfRef = useRef(null);
	async function handleConfirmDelete() {
		try {
			await delete_credit_note([id]);
			toast.success('Credit Note Deleted Successfully.');
			navigate(`/user/${suburl}/credit-note`);
		} catch (error) {
			toast.error(error?.message || 'Something went wrong');
		}
	}

	async function handleCreditNotePrintAndDownloadPdf(type = 'print') {
		try {
			setLoader(true);
			const pdf_details = await generatePurchaseCreditNotePdf(id);
			const url = pdf_details.signed_url;

			if (type === 'print') {
				window.open(url, '_blank');
			}

			if (type === 'download') {
				const fileName = `merged_purchase_credit_note_${Date.now()}.pdf`;
				const response = await fetch(url);
				const blob = await response.blob();
				const blobUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = fileName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(blobUrl);
			}
		} catch (err) {
		} finally {
			setLoader(false);
		}
	}

	async function handleFetchCreditNoteDetails() {
		try {
			const { credit_note } = await getCreditNoteDetails(id);
			setCreditNoteDetails(credit_note);
		} catch (error) {
			toast.error('Someting went wrong!');
		}
	}

	useEffect(() => {
		if (id) {
			handleFetchCreditNoteDetails();
		}
	}, [id]);

	useEffect(() => {
		if (creditNoteDetails) {
			document.title = `${creditNoteDetails?.credit_note_number} | Credit Note Details | Pharmnex`;
		}
	}, [creditNoteDetails]);

	return !creditNoteDetails ? (
		<PageLoader />
	) : (
		<div style={{ backgroundColor: '#EDEDF7', height: '100%', overflow: 'auto' }}>
			<div className="">
				<div
					className=""
					style={{
						position: 'sticky',
						top: 0,
						zIndex: 100,
					}}
				>
					<div className="product-pg-header add-product">
						<p>Credit Note Detail</p>
						<div className="add-product-button">
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								disabled={
									!hasPermission('purchases.credit_note.edit', user?.role?.role_permissions)
								}
								button="Edit"
								onClick={() => navigate(`/user/${suburl}/credit-note-create/${id}`)}
							/>
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								button="Pdf/Print"
								disabled={
									!hasPermission(
										'purchases.credit_note.download_or_print_pdf',
										user?.role?.role_permissions,
									)
								}
								loader={loader}
								onClick={() => handleCreditNotePrintAndDownloadPdf()}
							/>
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								disabled={
									!hasPermission(
										'purchases.credit_note.communications_email',
										user?.role?.role_permissions,
									)
								}
								button="Send Email"
								onClick={() => navigate(`/user/${suburl}/credit-note-send-emails/${id}`)}
							/>
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								disabled={!hasPermission('sales.invoices.create', user?.role?.role_permissions)}
								button="Apply to invoice"
								onClick={() => setIsApplyInvoice(true)}
							/>
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								disabled={
									!hasPermission('purchases.credit_note.delete', user?.role?.role_permissions)
								}
								button="Delete"
								onClick={() => setIsDeleteModalOpen(true)}
							/>
							<Button
								type="button"
								className="mt-0 btn-danger add-pro"
								button=""
								close
								onClick={() => navigate(`/user/${suburl}/credit-note`)}
							/>
						</div>
					</div>
				</div>

				{/* Credit Note Details */}
				<div ref={printPdfRef}>
					<div
						style={{
							maxWidth: '750px',
							margin: '19px auto',
							minHeight: '600px',
							backgroundColor: '#fff',
							padding: '20px',
							boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
						}}
					>
						{/* Store Details */}
						<div style={{ border: '1px solid #555B67', padding: '12px' }}>
							<div style={{ display: 'flex', justifyContent: 'space-between' }}>
								<div style={{ marginBottom: '20px' }}>
									<h4 style={{ marginBottom: '13px', fontWeight: 'bold', fontSize: '22px' }}>
										{creditNoteDetails?.vendor?.vendor_name}
									</h4>
									<p style={{ color: '#555B67', fontSize: '14px' }}>
										{creditNoteDetails?.vendor?.vendor_address?.street_1 || 'N/A'}
									</p>
									<p style={{ color: '#555B67', fontSize: '14px' }}>
										{`${creditNoteDetails?.vendor?.vendor_address?.state?.name || 'N/A'}, ${creditNoteDetails?.vendor?.vendor_address?.country?.name || 'N/A'}-${creditNoteDetails?.vendor?.vendor_address?.zip_code || 'N/A'}`}
									</p>
									<p style={{ color: '#555B67', fontSize: '14px' }}>
										{creditNoteDetails?.vendor?.phone_mobile}
									</p>
									<p style={{ color: '#555B67', fontSize: '14px' }}>
										{creditNoteDetails?.vendor?.email}
									</p>
								</div>

								<div>
									<h2
										style={{
											fontSize: '24px',
											color: '#000000',
											fontWeight: '600',
											textAlign: 'end',
											marginBottom: '12px',
										}}
									>
										Credit Note
									</h2>
									<p style={{ color: '#555B67', fontSize: '14px' }}>
										{creditNoteDetails?.credit_note_type
											? Number(creditNoteDetails?.credit_note_type) === 1
												? 'Damaged/Return Goods'
												: creditNoteDetails?.credit_note_type &&
													  Number(creditNoteDetails?.credit_note_type) === 2
													? 'Excess Payment'
													: 'Advance Payment'
											: ''}
									</p>
								</div>
							</div>

							{/* Payment Info */}
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'flex-start',
									marginBottom: '20px',
								}}
							>
								<div>
									<div className="d-flex">
										<div style={{ marginTop: '5px', color: '#555B67' }}>
											<p style={{ marginBottom: '16px' }}>Credit Note#</p>
											<p style={{ marginBottom: '16px' }}>Date</p>
											<p style={{ marginBottom: '16px' }}>Credit Note Date</p>
											<p style={{ marginBottom: '16px' }}>Reference Number</p>
											<p style={{ marginBottom: '16px' }}>Amount Paid In Words</p>
										</div>
										<div style={{ width: '270px', marginLeft: '35px', fontWeight: 'bold' }}>
											<p style={{ borderBottom: '1px solid #E5E6E8', marginBottom: '20px' }}>
												{creditNoteDetails?.credit_note_number}
											</p>
											<p style={{ borderBottom: '1px solid #E5E6E8', marginBottom: '15px' }}>
												{getDate(creditNoteDetails?.date)}
											</p>
											<p style={{ borderBottom: '1px solid #E5E6E8', marginBottom: '15px' }}>
												{getDate(creditNoteDetails?.credit_note_date)}
											</p>
											<p style={{ borderBottom: '1px solid #E5E6E8', marginBottom: '15px' }}>
												{creditNoteDetails?.reference_number || 'N/A'}
											</p>
											<p style={{ borderBottom: '1px solid #E5E6E8' }}>
												{numberToWords(
													Number(
														creditNoteDetails?.credit_note_type === 1 ||
															creditNoteDetails?.credit_note_type === 2
															? creditNoteDetails?.credit_note_amount
															: creditNoteDetails?.payment_amount,
													),
												)}
											</p>
										</div>
									</div>
								</div>

								<div
									style={{
										backgroundColor: '#84AD5F',
										width: '170px',
										height: '110px',
										marginTop: '18px',
										color: 'white',
										textAlign: 'center',
									}}
								>
									<div style={{ marginTop: '32px' }}>
										<p style={{ marginRight: '24px' }}> Credit Amount</p>
										<p style={{ fontSize: '20px', fontWeight: '600' }}>
											{'Rs. '}
											{creditNoteDetails?.credit_note_type === 1 ||
											creditNoteDetails?.credit_note_type === 2
												? Number(creditNoteDetails?.credit_note_amount).toFixed(2)
												: Number(creditNoteDetails?.payment_amount).toFixed(2)}
										</p>
									</div>
								</div>
							</div>

							{/* Paid To */}
							<div style={{ marginBottom: '20px' }}>
								<p style={{ fontWeight: 'bold', margin: 0 }}>Paid To</p>
								<a
									href="#"
									style={{ color: '#3B58FF', textDecoration: 'none', fontWeight: 'bold' }}
								>
									{creditNoteDetails?.organisation?.organisation_name}
								</a>
							</div>

							{/* Table */}
							{creditNoteDetails &&
							(Number(creditNoteDetails?.credit_note_type) === 1 ||
								Number(creditNoteDetails?.credit_note_type) === 3) ? (
								<table
									style={{
										width: '100%',
										border: '1px solid #dee2e6',
										borderCollapse: 'collapse',
										textAlign: 'left',
									}}
								>
									<thead>
										{creditNoteDetails && Number(creditNoteDetails?.credit_note_type) === 1 ? (
											<tr
												style={{ backgroundColor: '#f1f3f5', fontWeight: 'bold', color: '#555B67' }}
											>
												<th
													style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'left' }}
												>
													ITEM & DESCRIPTION
												</th>
												<th
													style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'left' }}
												>
													MFG DATE
												</th>
												<th
													style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'left' }}
												>
													EXP DATE
												</th>
												<th
													style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'left' }}
												>
													QTY
												</th>
												<th
													style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'left' }}
												>
													TAX
												</th>
												<th
													style={{
														padding: '8px',
														border: '1px solid #dee2e6',
														textAlign: 'right',
													}}
												>
													RATE
												</th>
												<th
													style={{
														padding: '8px',
														border: '1px solid #dee2e6',
														textAlign: 'right',
													}}
												>
													AMOUNT
												</th>
											</tr>
										) : (
											<tr
												style={{ backgroundColor: '#f1f3f5', fontWeight: 'bold', color: '#555B67' }}
											>
												<th
													style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'left' }}
												>
													ITEM & DESCRIPTION
												</th>
												<th
													style={{
														padding: '8px',
														border: '1px solid #dee2e6',
														textAlign: 'right',
													}}
												>
													ADVANCE AMOUNT
												</th>
											</tr>
										)}
									</thead>
									<tbody>
										{creditNoteDetails?.credit_note_products &&
										Number(creditNoteDetails?.credit_note_type) === 1 ? (
											creditNoteDetails?.credit_note_products?.map((pb) => (
												<tr>
													<td
														style={{
															padding: '8px',
															border: '1px solid #dee2e6',
															textAlign: 'left',
															color: '#3B58FF',
															cursor: 'pointer',
														}}
														onClick={() => {
															setProductDetails(pb);
															setIsSidebarOpen(true);
														}}
													>
														<strong>{pb?.product?.product_name}</strong>
														<br />
														<strong
															style={{ color: 'grey' }}
															onClick={() => {
																setProductDetails(pb);
																setIsSidebarOpen(true);
															}}
														>
															{pb?.batch_no}
														</strong>
													</td>
													<td
														style={{
															padding: '8px',
															border: '1px solid #dee2e6',
															textAlign: 'left',
															color: '#555B67',
														}}
													>
														{getDate(pb?.mfg_date)}
													</td>
													<td
														style={{
															padding: '8px',
															border: '1px solid #dee2e6',
															textAlign: 'left',
															color: '#555B67',
														}}
													>
														{getDate(pb?.exp_date)}
													</td>
													<td
														style={{
															padding: '8px',
															border: '1px solid #dee2e6',
															textAlign: 'left',
															color: '#555B67',
														}}
													>
														{pb?.quantity}
													</td>
													<td
														style={{
															padding: '8px',
															border: '1px solid #dee2e6',
															textAlign: 'right',
															color: '#555B67',
														}}
													>
														{pb?.tax}
													</td>
													<td
														style={{
															padding: '8px',
															border: '1px solid #dee2e6',
															textAlign: 'right',
															color: '#555B67',
														}}
													>
														{pb?.mrp}
													</td>
													<td
														style={{
															padding: '8px',
															border: '1px solid #dee2e6',
															textAlign: 'right',
															color: '#555B67',
														}}
													>
														{pb?.amount}
													</td>
												</tr>
											))
										) : (
											<tr>
												<td
													style={{
														padding: '8px',
														border: '1px solid #dee2e6',
														textAlign: 'left',
														color: '#555B67',
													}}
												>
													Advance Payment
												</td>
												<td style={{ textAlign: 'right' }}>{creditNoteDetails?.payment_amount}</td>
											</tr>
										)}
									</tbody>
								</table>
							) : (
								<PaymentMadeDetailTable
									tableColumns={['Bill Number', 'Bill Date', 'Bill Amount', 'Excess Paid Amount']}
									tableRows={creditNoteDetails?.credit_note_excess_bills}
									setPbId={setPbId}
									setIsPBDrawerOpen={setIsPBDrawerOpen}
									type={'cn'}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
			{isApplyInvoice && (
				<ApplyInvoice
					invoiceDetails={creditNoteDetails}
					isApplyInvoice={isApplyInvoice}
					setIsApplyInvoice={setIsApplyInvoice}
				/>
			)}
			{isSidebarOpen && (
				<ProductDetailsDrawer
					id={productDetails?.product_id}
					vendor={{
						vendor_id: creditNoteDetails?.vendor?.vendor_id,
						vendor_name: creditNoteDetails?.vendor?.vendor_name,
					}}
					setIsSidebarOpen={setIsSidebarOpen}
				/>
			)}
			{
				<BillDetailDrawer
					isOpen={isPBDrawerOpen}
					onClose={() => setIsPBDrawerOpen(false)}
					id={pbId}
				/>
			}
			{isDeleteModalOpen && (
				<ConfirmationModal
					isOpen={isDeleteModalOpen}
					onCancel={() => setIsDeleteModalOpen(false)}
					onOk={handleConfirmDelete}
					title="Confirm Deletion"
					content={
						<p
							style={{
								textAlign: 'center',
								backgroundColor: '#E6F5FF',
								padding: '10px',
								borderRadius: '5px',
								fontWeight: '500',
								color: 'black',
							}}
						>
							Are you sure you want to delete{' '}
							<span style={{ fontWeight: '600' }}>{creditNoteDetails?.credit_note_number}</span>?
						</p>
					}
				/>
			)}
		</div>
	);
};

export default CreditNoteDetails;
